import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CLIENTS_QUERY_KEYS } from "Clients/Api/Queries/queryKeys";
import {
  type DocumentUploadRequest,
  postClientsClientIDDocuments,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useUploadClientDocumentMutation(clientID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      ({ file, displayName }: DocumentUploadRequest) =>
        postClientsClientIDDocuments({ file, displayName }, clientID),
      {
        translationPrefix: getResourcePath(Resources.ApiErrors.DocumentUpload),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.documents(clientID),
      });
    },
  });
}
